import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '云开体育',
    url: 'https://yunkaipai.github.io',
    description: '云开体育是专注体育运动领域的综合服务平台，提供体育培训、赛事组织、运动装备及场馆管理等一站式解决方案。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://yunkaipai.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '云开体育',
    url: 'https://yunkaipai.github.io',
    description: '专业体育运动解决方案平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '上海',
      addressRegion: '浦东新区',
      streetAddress: '张江高科技园区体育中心A座',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <StatsSection />
        <CategoriesSection />
        <ArticlesSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}